import React from 'react';
import classNames from 'classnames';
import { compose } from 'redux';
import {connect} from 'react-redux';
import Icon from '@mdi/react';
import { mdiCheckboxMarked } from '../../../../../images/svg';

const ValidIcon = () =>
  <div className="valid-form-icon">
    <Icon path={mdiCheckboxMarked} size={0.8} color="#35Ce8d" />
  </div>

const RequiredText = ({ text }) =>
  <span className="required-text">[{ text }]</span>;

const RenderStatus = ({ valid, required, requiredText }) => {
  if (valid) {
    return <ValidIcon/>;
  }
  else if (required) {
    return <RequiredText text={requiredText}/>;
  }
  else {
    return null;
  }
}

export const FormLabel = compose(
  connect((state) => ({
    systemMessages: state.chatRoot.systemMessages,
  }))
)(({
  utilText,
  systemMessages,
  label,
  valid,
  required,
  showStatus = true,
}) => {
  const utilClassName = classNames('cu-ui-form-label-util', {
    'is-valid':   valid,
    'is-invalid': !valid
  });

  return (
    <label className="cu-ui-form-label">
      <span className="cu-ui-form-label-label">
        { label }
      </span>

      {showStatus && (
        <div className="cu-ui-form-label-status">
          <RenderStatus valid={valid} required={required} requiredText={systemMessages.required}/>
        </div>
      )}

      <span className={utilClassName}>
        { utilText }
      </span>
    </label>
  );
});
